import axios from 'axios';
import { store } from '../app/store';
import { loginSuccess, logout } from '../features/auth/authSlice';

// Development: React proxy (package.json "proxy") localhost:7264'e yönlendirir
// Production:  Aynı domain'de olduğu için relative URL direkt backend'e gider
const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use((config) => {
  const token = store.getState().auth.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const token = store.getState().auth.token;
        if (!token) {
          store.dispatch(logout());
          return Promise.reject(error);
        }

        const response = await axios.post('/api/Auth/refresh-token', { token });
        const newToken = response.data.token;

        store.dispatch(loginSuccess({
          ...store.getState().auth.user,
          token: newToken,
        }));

        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        store.dispatch(logout());
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;